// Nominated-nonprofit invitation (F4C 2027+). Set by EventRegistration when the page is opened with ?invite=CODE.
export const INVITE_STORAGE_KEY = 'f4c_invite_code';
export const INVITE_DETAILS_KEY = 'f4c_invite_details';

export const getStoredInvite = () => {
    try {
        const raw = localStorage.getItem(INVITE_DETAILS_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (e) {
        return null;
    }
};

export const clearStoredInvite = () => {
    localStorage.removeItem(INVITE_STORAGE_KEY);
    localStorage.removeItem(INVITE_DETAILS_KEY);
};
